import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import * as pdfjs from 'pdfjs-dist';
import 'turn.js';

const PDFFlipbook = () => {
    const [images, setImages] = useState([]);
    const pdfUrl = "https://api.notesmania.in/serve-pdf.php?file=public%2Fpdf%2F67726164d2b9f_50%20page%20sample%20PDF.indd.pdf";

    useEffect(() => {
        // Set pdf.js workerSrc
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

        const loadPdf = async () => {
            try {
                const pdf = await pdfjs.getDocument(pdfUrl).promise;
                const numPages = pdf.numPages;
                const pagePromises = [];

                // Loop through all pages of the PDF
                for (let pageNum = 1; pageNum <= numPages; pageNum++) {
                    pagePromises.push(
                        pdf.getPage(pageNum).then(page => {
                            const viewport = page.getViewport({ scale: 1 });
                            const canvas = document.createElement('canvas');
                            const context = canvas.getContext('2d');
                            canvas.height = viewport.height;
                            canvas.width = viewport.width;

                            return page.render({ canvasContext: context, viewport: viewport }).promise.then(() => {
                                return canvas.toDataURL();  // Get image as data URL
                            });
                        })
                    );
                }

                // Once all pages are converted to images, update the state
                const images = await Promise.all(pagePromises);
                setImages(images);

            } catch (error) {
                console.error("Error loading PDF", error);
            }
        };

        loadPdf();
    }, []);

    useEffect(() => {
        // Initialize the flipbook once images are loaded
        if (images.length > 0) {
            $('#flipbook').turn({
                gradients: true,
                acceleration: true,
                pages: images.length,
            });
        }
    }, [images]);

    return (
        <div>
            <div
                id="flipbook"
                style={{
                    width: '80%',
                    height: '500px',
                    margin: '50px auto',
                }}
            >
                {images.map((imgSrc, index) => (
                    <div
                        key={index}
                        className="page"
                        style={{
                            backgroundImage: `url('${imgSrc}')`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            width: '100%',
                            height: '100%',
                            display: 'block',
                        }}
                    ></div>
                ))}
            </div>
        </div>
    );
};

export default PDFFlipbook;
